// CEE page component
export function EPCPage() {
  return `
<div class="hero">
  <div class="hero-content">
    <h1 class="hero-title">Sobre los certificados energéticos</h1>
    <p class="hero-subtitle">El certificado energético obligatorio por ley</p>
  </div>
</div>

<section class="section bg-gray-50">
  <div class="container">
    <div class="max-w-6xl mx-auto prose prose-lg">

      <div class="flex flex-col md:flex-row md:items-start md:space-x-8">

        <div class="bg-white p-8 rounded-lg shadow-sm md:w-2/3">

          <h2 class="text-2xl text-blue-900 mb-4">Solicita tu certificado energético de forma rápida y sencilla a través de CEEcasasespaña.com</h2>

          <p>El certificado energético (Certificado de Eficiencia Energética) indica cuán eficiente es en energía tu vivienda o local comercial en España. ¡Información valiosa! Pero, ¿por qué es obligatorio este certificado? ¿Y para qué sirve?</p>

          <h3 class="text-xl text-blue-900 mt-4 mb-2">¿Por qué un certificado energético en España?</h3>
          <p>El planeta se está calentando, y también en España las normas son cada vez más estrictas para reducir el consumo energético y las emisiones de CO₂. Una gran parte de estas emisiones proviene de los edificios: calefacción, refrigeración e iluminación consumen mucha energía. Para hacerlo visible, el gobierno español (según el Real Decreto 390/2021) ha declarado obligatorio el certificado energético. De este modo, todos pueden ver cuán eficiente es un edificio y se fomenta el ahorro energético.</p>

          <p>El certificado energético es obligatorio en España cuando vas a:</p>
          <ul>
            <li>vender una vivienda o local,</li>
            <li>alquilarlo, o</li>
            <li>construir uno nuevo.</li>
          </ul>

          <p>Sin un certificado válido (Certificado de Eficiencia Energética) el inmueble no puede anunciarse oficialmente, y puedes recibir una multa de entre 300 € y 6.000 €, dependiendo de la gravedad de la infracción.</p>

          <p class="mt-4 mb-2"><a href="/epc/info/#why-energy-label" data-route="/epc/info/#why-energy-label" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Leer más sobre por qué es importante un certificado energético →</a></p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">¿Qué es un certificado energético?</h3>
          <p>El certificado energético español compara el rendimiento energético de los edificios. En el certificado aparece una clasificación de la A a la G:</p>
          <ul>
            <li>A significa muy eficiente energéticamente</li>
            <li>G significa que el edificio consume mucha energía</li>
          </ul>

          <p>La puntuación se basa en factores como:</p>
          <ul>
            <li>aislamiento de paredes, ventanas y cubiertas,</li>
            <li>el tipo de sistema de calefacción y refrigeración,</li>
            <li>ventilación, y</li>
            <li>energías renovables como paneles solares o bombas de calor.</li>
          </ul>

          <p>El certificado lo elabora un técnico certificador autorizado que inspecciona la vivienda según la metodología oficial.</p>

          <p>¿No sabes si tu vivienda ya tiene un certificado válido? Puedes comprobarlo en el Registro Autonómico de Certificados de Eficiencia Energética de tu comunidad (por ejemplo: Andalucía, Valencia, Madrid, etc.).</p>

          <p>Un certificado energético en España tiene una validez de diez años.</p>

          <p class="mt-4 mb-2"><a href="/epc/info/#what-is-energy-label" data-route="/epc/info/#what-is-energy-label" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Leer más sobre qué incluye exactamente un certificado energético →</a></p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">¿Para qué sirve un certificado energético?</h3>
          <p>Además de ser obligatorio para venta, alquiler o nueva construcción, el certificado ofrece ventajas prácticas:</p>
          <ul>
            <li>Ves de inmediato cuán eficiente es tu vivienda.</li>
            <li>Sabes dónde puedes mejorar para ahorrar energía (y dinero).</li>
            <li>Un mejor certificado suele aumentar el valor y la facilidad de alquiler de tu vivienda.</li>
          </ul>

          <p class="mt-4 mb-2"><a href="/epc/info/#what-is-the-benefit-of-an-energy-label" data-route="/epc/info/#what-is-the-benefit-of-an-energy-label" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Leer más sobre los beneficios de un certificado energético →</a></p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">Preguntas frecuentes sobre certificados energéticos en España</h3>
          <p>¿Tienes dudas sobre solicitar o renovar un certificado energético? Hemos creado un práctico resumen con preguntas frecuentes.</p>

          <p class="mt-4 mb-2"><a href="/faq-customer/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Ir a todas las preguntas frecuentes →</a></p>

        </div>

        <div class="p-8 rounded-lg shadow-sm md:w-1/3" style="background: linear-gradient(335deg, rgba(63, 137, 233, 0.85), rgba(121, 211, 238, 0.75));">
          <img src="/images/team/compare.webp" alt="Compara asesores de certificados energéticos" class="mb-4 w-full h-auto rounded-md object-cover" />

          <p class="mb-4">Compara asesores de certificados energéticos.  
          Compara precios, calidad y rapidez según tus datos.</p>

          <p><a href="/cadastro/" data-route="/cadastro/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Comparar ahora -></a></p>
        </div>

      </div>

    </div>
  </div>
</section>

  `;
}
